import { CourseAdminCard } from '@/components/shared/CourseAdminCard';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { formatRecordDateTime } from '@/utils/assessments/recordDateTime';

type RecordCardMetaProps = {
  datetime: string;
  authorName?: string;
  muted?: boolean;
};

export default function RecordCardMeta({
  datetime,
  authorName,
  muted,
}: RecordCardMetaProps) {
  return (
    <CourseAdminCard.TitleBlock className="w-32 shrink-0 gap-1">
      <ConditionalRenderer condition={!!authorName}>
        <p className="truncate text-12 leading-5">{authorName}</p>
      </ConditionalRenderer>
      <p
        className={`whitespace-nowrap text-sm leading-5 ${
          muted ? 'text-base-content/50' : ''
        }`}
      >
        {formatRecordDateTime(datetime)}
      </p>
    </CourseAdminCard.TitleBlock>
  );
}
